var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"ws-heptalist"},_vm._l((_vm.texts),function(text,index){return _c('li',{key:text},[_c('div',[_c('ws-badge',[_vm._v(_vm._s(index + '.'))])],1),_c('p',[_vm._v(_vm._s(text))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }